<template>
  <div id="main-page" class="w-100">
    <div :class="is_full_image? '' : 'padded-container'">
      <StoryBoardMain :mp4Url="mp4Url" :imageUrl="imageUrl"></StoryBoardMain>
    </div>

    <template v-if="selected_main_option.includes('company_description')">
      <mainCommitments></mainCommitments>
    </template>

    <template v-if="selected_main_option.includes('company_achievement')">
      <div class="bgray-100 py-5">
        <h1 class="achievement-section-title text-center padded-container fw-700" id="title_achievement-card">
              {{
                lang === 'KOR'
                  ? main_setting?.main_performance_info?.title
                  : main_setting?.main_performance_info?.title_e
              }}
            </h1>
        <b-row no-gutters class="achievements padded-container ">

          <b-col cols="10" class="padded-container">
            <b-row class="justify-content-start achievements-card-group right">
              <b-col
                v-for="(main_link_info, index) in main_setting?.main_performance_info?.sb_main_links"
                :key="`achievements-${index}`"
                cols="12"
                md="6"
                xl="4"
                :class="[
                  'p-xl-4 p-3',
                  'border-black',
                  index % 1 !== 0 && windowWidth < 768 ? 'no-border-left' : '',
                  index % 2 !== 0 && windowWidth >= 768 && windowWidth < 1200 ? 'no-border-left' : '',
                  index % 3 !== 0 && windowWidth >= 1200 ? 'no-border-left' : '',
                  index >= 1 && windowWidth < 768 ? 'no-border-top' : '',
                  index >= 2 && windowWidth >= 768 && windowWidth < 1200 ? 'no-border-top' : '',
                  index >= 3 && windowWidth >= 1200 ? 'no-border-top' : '',
                ]"
              >
                <achievementsCard
                  :label="lang === 'KOR' ? main_link_info.content : main_link_info.content_e"
                  :bootstrap_icon="main_link_info.bootstrap_icon"
                  :link="lang === 'KOR' ? main_link_info.url : main_link_info.url_e"
                  :hovering-index="hoveringIndex"
                  :index="index"
                  @hover="updateHoverIndex"
                >
                  {{ lang === 'KOR' ? main_link_info.title : main_link_info.title_e }}
                </achievementsCard>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
      
    </template>

    <template v-if="selected_main_option.includes('company_topic')">
      <div class="padded-container pt-5">
        <b-row no-gutters class="section-highlight">
          <b-col cols="10" class="section-highlight-header padded-container text-center">
            <h1 class="achievement-section-title fw-700" id="title_highlight-card">
              {{
                lang === 'KOR'
                  ? main_setting?.main_topic_info?.title
                  : main_setting?.main_topic_info?.title_e
              }}
            </h1>
          </b-col>
          <b-col cols="10">
            <sectionHighlight />
          </b-col>
        </b-row>
      </div>

    </template>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import StoryBoardMain from '@/components/report_preview/story_board/main/StoryBoardMain';
  import mainCommitments from '@/components/report_preview/story_board/main/main-commitments';
  import achievementsCard from './achievements-card.vue';
  import sectionHighlight from './section-highlight.vue';

  export default {
    name: 'IndexPage',
    components: {
      StoryBoardMain,
      mainCommitments,
      achievementsCard,
      sectionHighlight,
    },
    layout: 'index',
    data() {
      return {
        windowWidth: window.innerWidth,
        observerTargets: null,
        mainpageIntersectionObserver: null,
        hoveringIndex: null,
      };
    },
    computed: {
      ...mapState('report_contents', ['theme_option']),
      ...mapState('report_list', ['lang']),
      ...mapGetters('report_list', ['current_report_code']),
      ...mapState('story_board', ['main_setting']),
      is_full_image() {
        return this.theme_option?.sb_theme_info?.is_full_image || false;
      },
      selected_main_option() {
        if (this.theme_option) {
          return this.theme_option?.sb_theme_info?.selected_main_option;
        } else {
          return ['company_description', 'company_achievement', 'company_topic'];
        }
      },
      imageUrl() {
        if (this.theme_option?.sb_theme_info?.unsplash_url) {
          return this.theme_option?.sb_theme_info?.unsplash_url;
        } else {
          return this.theme_option?.sb_theme_info?.main_cover_img_path
            ? this.$store.state.static_host + this.theme_option?.sb_theme_info?.main_cover_img_path
            : null;
        }
      },
      mp4Url() {
        return this.theme_option?.sb_theme_info?.main_cover_mp4_path
          ? this.$store.state.static_host + this.theme_option?.sb_theme_info?.main_cover_mp4_path
          : null;
      },
    },
    watch: {
      current_report_code: {
        immediate: true,
        handler(newVal) {
          if (newVal) {
            // this.get_theme_info({ report_code: newVal });
          }
        },
      },
    },
    mounted() {
      this.observerTargets = document.querySelectorAll('[data-transition-effect]');
      this.mainpageIntersectionObserver = new IntersectionObserver(
        (entries, observer) => {
          if (entries.length) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (entry.target.dataset.transitionEffect) {
                  const transitionEffect = entry.target.dataset.transitionEffect;
                  entry.target.classList.add(`transition-effect-${transitionEffect}`);
                }

                if (entry.target.dataset.transitionDuration) {
                  const transitionDuration = entry.target.dataset.transitionDuration;
                  entry.target.classList.add(`transition-duration-${transitionDuration}`);
                }

                if (entry.target.dataset.transitionDelay) {
                  const transitionDelay = entry.target.dataset.transitionDelay;
                  entry.target.classList.add(`transition-delay-${transitionDelay}`);
                }

                if (entry.target.hasAttribute('data-transition-show')) {
                  if (entry.target.hasAttribute('data-transition-show-delay')) {
                    setTimeout(() => {
                      entry.target.classList.add('show');
                    }, Number(entry.target.dataset.transitionShowDelay));
                  } else {
                    entry.target.classList.add('show');
                  }
                }

                if (entry.target.hasAttribute('data-loaded')) {
                  const elementLaodedTiming = entry.target.dataset.loaded;
                  setTimeout(
                    () => {
                      entry.target.classList.add('loaded');
                    },
                    !elementLaodedTiming ? 0 : Number(elementLaodedTiming)
                  );
                }

                observer.unobserve(entry.target);
              }
            });
          }
        },
        {
          threshold: 0.5,
        }
      );

      if (this.observerTargets.length) {
        this.observerTargets.forEach((observerTarget) => {
          this.mainpageIntersectionObserver.observe(observerTarget);
        });
      }
      window.addEventListener('resize', this.updateWindowWidth);
    },
    beforeDestroy() {
      this.mainpageIntersectionObserver.disconnect();
      window.removeEventListener('resize', this.updateWindowWidth);
    },
    methods: {
      ...mapActions('report_contents', ['get_theme_info']),
      updateHoverIndex(index) {
        this.hoveringIndex = index;
      },
      updateWindowWidth() {
        this.windowWidth = window.innerWidth;
      },
    },
  };
</script>

<style lang="scss" scoped>
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: -0.01px;
    color: #111111;
  }

  h5 {
    font-weight: 600;
  }

  h6 {
    font-weight: 500;
  }

  .achievements,
  .section-highlight,
  .section-media {
    min-height: calc(100vh - 190px);
    margin-bottom: 100px;
    display: flex;
    justify-content: center;
  }

  h6 {
    font-size: 1.1rem;

    @media screen and (max-width: 767.98px) {
      font-size: 0.9rem;
    }

    @media screen and (min-width: 768px) and (max-width: 1199.98px) {
      font-size: 0.9rem;
    }

    @media screen and (min-width: 1200px) and (max-width: 1679.98px) {
      font-size: 1rem;
    }

    @media screen and (min-width: 1680px) {
      font-size: 1.1rem;
    }
  }
</style>
